export default __webpack_public_path__ + "static/media/search.7ee9fbf1.svg";